module.exports = __webpack_public_path__ + "img/leftArrow.692dfb45.svg";